var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartFoxLogoPartialWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68819 2H21.676C22.8645 2 23.828 2.96352 23.828 4.15208C23.828 5.34064 22.8645 6.30416 21.676 6.30416H8.62299C6.18776 6.30416 4.21364 8.2783 4.21364 10.7135C4.21364 13.1487 6.18777 15.1229 8.62299 15.1229H15.1807C16.3554 15.1229 17.3074 16.0751 17.3074 17.2496C17.3074 18.4242 16.3554 19.3764 15.1807 19.3764H8.65374C3.87441 19.3764 0 15.4848 0 10.7055C0 5.90709 3.88983 2 8.68819 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3117 25.9999H2.32395C1.13539 25.9999 0.171875 25.0364 0.171875 23.8478C0.171875 22.6592 1.13539 21.6958 2.32395 21.6958H15.3626C17.7978 21.6958 19.772 19.7216 19.772 17.2864C19.772 14.8512 17.7978 12.8771 15.3626 12.8771H8.76046C7.58589 12.8771 6.6337 11.9248 6.6337 10.7503C6.6337 9.57568 7.58589 8.62354 8.76046 8.62354H15.3168C20.1123 8.62354 23.9998 12.5137 23.9998 17.3092C23.9998 22.1075 20.1101 25.9999 15.3117 25.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartFoxLogoPartialWhite);
export default __webpack_public_path__ + "static/media/SmartFoxLogoPartialWhite.cc604ddb864d40d3d7be2e393f8ef90a.svg";
export { ForwardRef as ReactComponent };